import React from "react";
import { Link, useParams } from "react-router-dom";
// import Quote from "./Quote";
import { findService, getServiceRoutes } from "./serviceData";

const ServiceLandingPage = () => {
  const { categorySlug, serviceSlug, subCategorySlug } = useParams();
  const service = findService(categorySlug, serviceSlug);
  const { subcategory, routes } = getServiceRoutes(service, subCategorySlug);

  if (!service || (subCategorySlug && !subcategory)) {
    return null;
  }

  const pageTitle = subcategory?.title || service.title;
  const pageDescription = subcategory?.description || service.description;

  return (
    <div className="bg-white pt-20">
      <section className="relative overflow-hidden bg-[rgb(26,36,58)] py-8 text-white lg:pt-20">
        <div className="container relative mx-auto px-4">
          <div className="max-w-3xl">
            <div className="mb-6 flex flex-wrap items-center gap-3 text-sm font-semibold text-[#C9A04A]">
              <Link to="/" className="hover:text-white">
                Home
              </Link>
              <span>/</span>
              <Link
                to={`/services/${categorySlug}`}
                className="hover:text-white"
              >
                {service.category}
              </Link>
              <span>/</span>
              {subcategory && (
                <>
                  <Link
                    to={`/services/${categorySlug}/${serviceSlug}`}
                    className="hover:text-white"
                  >
                    {service.title}
                  </Link>
                  <span>/</span>
                </>
              )}
              <span>{pageTitle}</span>
            </div>
            <h1 className="mb-6 text-4xl font-bold leading-tight lg:text-6xl">
              {pageTitle}
            </h1>
            <p className="max-w-2xl text-base leading-8 text-white/85 lg:text-lg">
              {pageDescription}
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-[#C9A04A] px-6 py-3 font-bold text-[rgb(26,36,58)] hover:bg-white"
              >
                Get advice
              </a>
              <a
                href="tel:+4401216306635"
                className="inline-flex items-center justify-center border border-white/40 px-6 py-3 font-bold text-white hover:border-yellow hover:text-[#C9A04A]"
              >
                Call +44 (0) 121 630 6635
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light-grey py-8">
        <div className="container mx-auto px-4">
          {service.subcategories && !subcategory && (
            <div className="mb-12 grid gap-6 md:grid-cols-2">
              {service.subcategories.map((group) => (
                <Link
                  key={group.slug}
                  to={`/services/${categorySlug}/${serviceSlug}/${group.slug}`}
                  className="rounded-lg bg-white p-8 shadow-panel transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg"
                >
                  <h3 className="text-center text-xl font-bold text-purple-600">
                    {group.title}
                  </h3>
                  <p className="mt-3 text-center leading-7 text-gray-600">
                    {group.description}
                  </p>
                </Link>
              ))}
            </div>
          )}
          <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
            {routes.map((route) => (
              <Link
                key={route.slug}
                to={
                  subcategory
                    ? `/services/${categorySlug}/${serviceSlug}/${subcategory.slug}/${route.slug}`
                    : `/services/${categorySlug}/${serviceSlug}/${route.slug}`
                }
                className="rounded-lg bg-white p-8 shadow-panel transition-transform duration-200 hover:-translate-y-1 hover:shadow-lg"
              >
                <h3 className="text-center text-xl font-bold text-purple-600">
                  {route.title}
                </h3>
                {/* <p className="leading-7 text-gray-600">{route.intro}</p> */}
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* <Quote /> */}
    </div>
  );
};

export default ServiceLandingPage;
